function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 100px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { Spin } from "antd";
var Spinner = styled.div(_templateObject());
var Loading = function() {
    return /*#__PURE__*/ React.createElement(Spinner, null, /*#__PURE__*/ React.createElement(Spin, null));
};
export default Loading;
